export const siteConfig = {
  siteTitle: 'AssistBnB | 民泊清掃・スケジュール管理・清掃漏れ防止・自動化・宿泊者台帳',
  siteDescription:
    'AssistBnB（assist bnb、アシストbnb）は、民泊清掃や宿泊者台帳の管理を効率化・自動化できるサービスです。民泊運営の負担を減らし、スムーズな運営をサポートします。',
  siteUrl: 'https://assistbnb.lilfires.com',
  siteImage: '/images/ogp.png',
  favicon: '/favicon.ico',
  email: 'assistbnb@lilfires.com',
  xUserId: '@assistbnb_'
} as const

export const siteConfigClean = {
  siteTitle: 'AssistBnB 清掃管理',
  siteDescription: '清掃予定を、自動で管理',
  siteUrl: 'https://assistbnb.lilfires.com',
  siteImage: '/images/ogp_clean.png',
  favicon: '/favicon.ico',
  email: 'assistbnb@lilfires.com',
  xUserId: '@assistbnb_'
} as const

export const siteConfigBinder = {
  siteTitle: 'エアビー・民泊の宿泊者名簿を自動作成 | AssistBnB宿泊者台帳',
  siteDescription:
    'Airbnb・民泊の宿泊者名簿を旅館業法に対応した形で自動作成。ゲストがフォームに入力するだけで本人確認書類まで収集でき、CSV出力にも対応。Googleフォームや紙の台帳から乗り換えられます。',
  siteUrl: 'https://assistbnb.lilfires.com',
  siteImage: '/images/ogp.png',
  favicon: '/favicon.ico',
  email: 'assistbnb@lilfires.com',
  xUserId: '@assistbnb_'
} as const

export const siteConfigMessageAi = {
  siteTitle: '民泊のゲスト対応をAIで自動化 | AssistBnB メッセージAI',
  siteDescription:
    '民泊ゲストからの問い合わせにAIが返信文を自動で下書き。AssistBnBの受信箱で確認して送るだけで返信が完了し、深夜の対応や定型文のコピペ作業から解放されます。',
  siteUrl: 'https://assistbnb.lilfires.com',
  siteImage: '/images/ogp.png',
  favicon: '/favicon.ico',
  email: 'assistbnb@lilfires.com',
  xUserId: '@assistbnb_'
} as const
